import {quadInOut} from 'svelte/easing';
export const fadeScale = (node, {duration, scale, origin = {x: 0.5, y: 0.5}}) => {
  return {
    duration,
    css: t => {
      const eased = quadInOut(t);

      const originX = typeof origin.x === 'number' ? (origin.x * 100) + '%' : origin.x;
      const originY = typeof origin.y === 'number' ? (origin.y * 100) + '%' : origin.y;

      return `
      transform: scale(${1 + ((scale || 0.7) - 1) * (1 - eased)});
      transform-origin: ${originX} ${originY};
      opacity: ${eased};
      `;
    }
  };
};